import { Model } from '@vuex-orm/core';
import { uuidv4 } from '@/utils/helpers';
import Invoice from '@/store/models/invoice';

export default class AdvancePayment extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'advance_payments';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      invoice_id: this.attr(null),
      invoice: this.belongsTo(Invoice, 'invoice_id'),
      description: this.attr(''),
      amount: this.attr(null),
      order: this.attr(null),
    };
  }
}
